// Fin d'envoi d'un retour vidéo coach (upload en arrière-plan).
//
// L'envoi part après la fermeture de la modale et prend souvent une à deux
// minutes (TUS puis PATCH /feedback, qui pose reviewed_at). Les listes qui ont
// déjà basculé la vidéo en « Complété » localement ont besoin de savoir quand
// le serveur est au courant — ou que l'envoi a échoué — pour se recaler.

const EVENT = 'kaiylo:coach-feedback-video-settled';

export function emitCoachFeedbackVideoSettled(videoId, ok) {
  if (typeof window === 'undefined' || !videoId) return;
  try {
    window.dispatchEvent(new CustomEvent(EVENT, { detail: { videoId, ok: !!ok } }));
  } catch {
    // best-effort
  }
}

export function onCoachFeedbackVideoSettled(listener) {
  if (typeof window === 'undefined') return () => {};
  const handler = (event) => listener(event.detail || {});
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
